/**
 * KAN-719: red line under the account status when the account is offline and its proxy
 * from the directory failed the last check. Tooltip: when the check ran.
 */
import type { TelegramAccount } from "@/types/telegramAccount";

function checkedTitle(checkedAt: string | null): string | undefined {
  if (!checkedAt) return undefined;
  const moment = new Date(checkedAt);
  if (Number.isNaN(moment.getTime())) return undefined;
  const text = moment.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Moscow",
  });
  return `Проверено: ${text} МСК`;
}

function proxyProblemText(
  problem: NonNullable<TelegramAccount["proxy_problem"]>,
): string {
  return problem.error
    ? `Прокси не работает: ${problem.error} (${problem.proxy})`
    : `Прокси не работает (${problem.proxy})`;
}

export function AccountProxyProblem({
  account,
}: {
  account: TelegramAccount;
}): JSX.Element | null {
  const problem = account.proxy_problem;
  if (!problem) return null;
  return (
    <div
      data-testid={`proxy-problem-${account.operator_id}-${account.account_id}`}
      className="mt-1 text-xs font-medium text-red-700 break-words"
      title={checkedTitle(problem.checked_at)}
    >
      {proxyProblemText(problem)}
    </div>
  );
}
